/* eslint-disable padding-line-between-statements */
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

let settings;
let cachingInProgress = false;

const shouldRefresh = () => {
    return !settings;
};

const until_Ext = (condition) => {
    
    const wait = (resolve) => {
        if (condition()) {
            resolve();
        } else {
            setTimeout(() => wait(resolve), 500);
        }
    }

    return new Promise(wait);
};

const getAndCacheSettings = async (additionalHeaders, forceRefresh) => {
    await until_Ext(() => cachingInProgress === false);
    if (shouldRefresh() || forceRefresh) {
        cachingInProgress = true;
        return JsonRPCService.send(getProxiedServiceUrl('policycommonPortalsettings'), 'getSettings',
            [], additionalHeaders).then((data) => {            
            settings = data;
            
            return data;
        }).finally(() => {
            cachingInProgress = false;
        });
    }    
    
    return Promise.resolve(settings);
};

export default class MLPortalSettingsService {

    static getSettings(additionalHeaders = {}, forceRefresh = false) {
        return getAndCacheSettings(additionalHeaders, forceRefresh);
    }

}